export default __webpack_public_path__ + "static/media/pending-transactions-active.a20c04dc.svg";